import { motion } from "framer-motion";
import { Leaf, Lock, Calendar, MapPin, Clock, Settings } from "lucide-react";

const REASONS = [
  { Icon: Leaf, title: "Canadian Business Support", body: "Built in Brampton, Ontario — we understand Canadian operations, compliance, and timezones." },
  { Icon: Lock, title: "Confidential & Secure", body: "NDAs available on request. Strict confidentiality practices for every engagement." },
  { Icon: Calendar, title: "Flexible Monthly Plans", body: "Few hours per week or a full outsourced team. Scale support to match your real workload." },
  { Icon: MapPin, title: "Remote & On-Site Support", body: "Work with us remotely from anywhere, or book weekly on-site visits across the GTA." },
  { Icon: Clock, title: "Fast Response Times", body: "Responsive, reliable, and consistent — week after week. No waiting around for answers." },
  { Icon: Settings, title: "Customized Business Solutions", body: "No cookie-cutter packages. Every plan is shaped around your workflow and tools." },
];

const VALUES = ["Professionalism", "Integrity", "Confidentiality", "Efficiency", "Accountability", "Excellence"];

export default function WhyUs() {
  return (
    <section id="why" className="relative py-28 lg:py-36" data-testid="why-section">
      <div className="container-apex">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="overline">Why Choose Admin Apex</div>
            <h2 className="heading-display text-4xl sm:text-5xl lg:text-6xl mt-5">
              Built around the way you actually <span className="text-[#16A34A]">run a business.</span>
            </h2>
            <p className="mt-6 text-muted-foreground text-lg">
              No cookie-cutter packages. No long-term lock-ins. Just dependable office support that frees you to focus on what only you can do.
            </p>

            <div className="mt-10">
              <div className="text-xs font-bold tracking-[0.3em] text-muted-foreground uppercase">Our Core Values</div>
              <div className="mt-4 flex flex-wrap gap-2">
                {VALUES.map((v) => (
                  <span key={v} className="px-3 py-1.5 rounded-full text-xs font-semibold bg-[#0B2545] text-white dark:bg-white dark:text-[#0B2545]">
                    {v}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {REASONS.map((r, i) => (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className={`card-apex p-7 ${i === 0 ? "sm:col-span-2 bg-[#16A34A]/5 border-[#16A34A]/30" : ""}`}
                data-testid={`why-card-${i}`}
              >
                <div className="w-11 h-11 rounded-xl bg-[#0B2545] text-white flex items-center justify-center">
                  <r.Icon size={18} />
                </div>
                <h3 className="mt-5 font-display font-bold text-xl">{r.title}</h3>
                <p className="mt-2 text-sm text-muted-foreground">{r.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
